import { memo } from 'react'

const ReceptionIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.924 3.837c0-.462.364-.837.812-.837h4.528c.449 0 .812.375.812.837a.825.825 0 0 1-.812.836h-1.452V6.5h1.452c1.716 0 3.363.702 4.576 1.952a6.771 6.771 0 0 1 1.896 4.715v3.499a.825.825 0 0 1-.812.836H4.076a.825.825 0 0 1-.812-.836v-3.499c0-1.768.682-3.464 1.896-4.715A6.377 6.377 0 0 1 9.736 6.5h1.452V4.673H9.736a.825.825 0 0 1-.812-.836Zm.812 4.335a4.777 4.777 0 0 0-3.428 1.463 5.072 5.072 0 0 0-1.42 3.531v2.662h14.224v-2.662c0-1.324-.51-2.595-1.42-3.531a4.777 4.777 0 0 0-3.428-1.463H9.736ZM1 20.163c0-.462.364-.836.812-.836h20.376c.448 0 .812.374.812.836a.825.825 0 0 1-.812.837H1.812A.825.825 0 0 1 1 20.163Z"
      clipRule="evenodd"
    />
  </svg>
)

export default memo(ReceptionIcon)
